import {
  Button,
  Center,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useRouter } from "next/router";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { getSdk } from "~/__generated__/graphql";
import client from "~/config/client";
import useNotify from "~/hooks/use-notify";
import InputField from "../forms/input-field";
interface PopUpProps {
  isOpen: boolean;
  onClose: () => void;
  topic: { category?: string | null; title?: string | null; tag: string };
  downloadLink?: string;
}

const schema = z.object({
  email: z.string({ coerce: true }).email("Invalid email address"),
  name: z.string({ coerce: true }),
});

type Schema = z.infer<typeof schema>;
const PopUp = (props: PopUpProps) => {
  const { handleSubmit, reset, register, formState } = useForm<Schema>({
    resolver: zodResolver(schema),
  });
  const { isOpen, onClose, topic, downloadLink } = props;
  const notify = useNotify();
  const [success, setSuccess] = useState(false);
  const router = useRouter();
  const subscribe = handleSubmit(async (data) => {
    try {
      const sdk = getSdk(client);

      await sdk.CreateRequest({
        data: {
          email: data.email,
          name: `${data.name ?? ""}`,
          details: { topic },
        },
      });

      // const advantePdfGuideSent = createRequest !== null;

      reset();
      setSuccess(true);
      // notify(
      //   <>
      //     {advantePdfGuideSent && <>Success! Your information has been submitted successfully.</>}
      //   </>,
      //   {
      //     title: advantePdfGuideSent ? <>Thank you!</> : null,
      //   },
      // );
    } catch (e) {
      notify(<>Oops! Something went wrong. Please try again later.</>, {
        variant: "danger",
      });
    }
  });
  const RenderContent = () => {
    return !success ? (
      <>
        <InputField
          chakraInputProps={{
            placeholder: "Full name",
            alignItems: "center",
            backgroundColor: "white",
            height: "44px",
            border: "1px solid #F0EDEC",
            boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
            mb: "12px",
          }}
          id={"name"}
          {...register("name")}
          label="Full name"
        />
        <InputField
          chakraInputProps={{
            placeholder: "you@gmail.com",
            alignItems: "center",
            backgroundColor: "white",
            height: "44px",
            border: "1px solid #F0EDEC",
            boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
          }}
          id={"email"}
          {...register("email")}
          errorMsg={formState.errors.email?.message}
          label="Email address"
        />
      </>
    ) : (
      <>
        <Text
          fontWeight={600}
          color="v2.blue.100"
          fontSize="18px"
          lineHeight={"28px"}
          textAlign={"center"}
          mb="8px"
        >
          Success! Your information has been submitted successfully.
        </Text>
        <Text
          textAlign={"center"}
          fontSize="14px"
          lineHeight={"20px"}
          letterSpacing="0.02em"
          color="rgba(13, 48, 80, 0.8)"
          mb="10px"
        >
          Thank you for submitting the form, please click the button below to download your
          resource.
        </Text>
      </>
    );
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        as="form"
        onSubmit={subscribe}
        width={{ lg: "400px", base: "343px" }}
        mx={{ lg: "unset", base: "16px" }}
        fontFamily={"'Inter',sans-serif"}
      >
        <ModalHeader color="v2.blue.100" fontSize={"16px"}>
          {!success ? (
            <Text
              w="full"
              letterSpacing={"0.02em"}
              lineHeight={"24px"}
              fontWeight={600}
              width="292px"
            >{`Get the "${topic.title}" by providing your information below.`}</Text>
          ) : (
            <Center>
              <Image src={"/icons/confetti.webp"} alt="success" />
            </Center>
          )}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <RenderContent />
        </ModalBody>

        <ModalFooter>
          <Flex
            w="full"
            height={{ lg: "44px", base: !success ? "100px" : "44px" }}
            gap={"12px"}
            direction={{ lg: "row", base: "column-reverse" }}
          >
            {!success ? (
              <>
                <Button
                  variant={"outline"}
                  w="full"
                  height={"44px"}
                  flex={1}
                  fontWeight={600}
                  color="v2.blue.100"
                  onClick={onClose}
                  fontSize={"18px"}
                >
                  Cancel
                </Button>
                <Button
                  flex={1}
                  w="full"
                  fontWeight={600}
                  color="v2.blue.100"
                  type="submit"
                  height={"44px"}
                  fontSize={"18px"}
                >
                  Submit
                </Button>
              </>
            ) : (
              <Button
                flex={1}
                w="full"
                fontWeight={600}
                color="v2.blue.100"
                type="submit"
                height={"44px"}
                fontSize={"18px"}
                onClick={() =>
                  downloadLink
                    ? router.push(downloadLink)
                    : notify(<>Oops! Something went wrong. Please try again later.</>, {
                        variant: "danger",
                      })
                }
              >
                Download
              </Button>
            )}
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PopUp;
